import type { Duration } from "luxon";

import type { MemSize } from "@core/foundation/units";

const COMPACT_FORMAT = new Intl.NumberFormat("en", {
  maximumFractionDigits: 1,
  notation: "compact",
});

const PERCENT_DECIMALS = 1;

export function formatBytes(size: MemSize): string {
  if (size.toGigabytes() >= 1) {
    return `${COMPACT_FORMAT.format(size.toGigabytes())} GB`;
  }

  if (size.toMegabytes() >= 1) {
    return `${COMPACT_FORMAT.format(size.toMegabytes())} MB`;
  }

  return `${COMPACT_FORMAT.format(size.toKilobytes())} KB`;
}

export function formatCount(value: number): string {
  return COMPACT_FORMAT.format(value);
}

export function formatDurationAsMinutes(duration: Duration): string {
  return `${COMPACT_FORMAT.format(duration.as("minutes"))} min`;
}

export function formatPercent(value: number): string {
  return `${value.toFixed(PERCENT_DECIMALS)}%`;
}
